import React from 'react';
import PropTypes from 'prop-types';
import getApiClient from 'react/services/api_client';
import EnrollTraining from '../dashboard/catalogs/catalogs_card/enroll.graphql';


function t(i18n_suffix) {
  return I18n.t(`js.front.learner.trainings.training_previews.show${i18n_suffix}`)
}

export default class EnrollmentButton extends React.Component {

  constructor(props) {
    super(props)

    this.apiClient = getApiClient();
    this.enroll = this.enroll.bind(this)
  }

  enroll(training_session_id, catalog_id) {
    this.apiClient.mutate({
      mutation: EnrollTraining,
      variables: {
        input: {
          training_session_id,
          catalog_id,
        },
      },
    }).then((result) => (window.location.reload()))
  }



  render(){
    return(
      <button className="button primary rounded margin-bottom-10" onClick={() => this.enroll(this.props.training_session_id, this.props.catalog_id)} >
        <i className="material-icons icon-text">add</i>
        <span className="vertical-align">{t(this.props.enrollment_approvals ? '.apply' : '.enroll')}</span>
      </button>
    )
  }
}
